export const pluralizeWord = (singular, plural, count) => (count > 1 ? plural : singular);
export const replaceSpacesWithUnderscore = str => str.replace(/\s+/g, '_');
export const truncateString = (str, maxLength) => str && (str.length > maxLength
  ? `${str.substring(0, maxLength)}...`
  : str);